<template>
  <div class="productShow">
    <div class="productShow-main">
      <ul>
        <li v-for="(item,index) in productShowList" :key="index" class="productShow-main-li">
          <div class="productShow-name">{{item.pictureName}}</div>
          <div class="productShow-img"><img :src="item.filePath"></div>
          <div class="productShow-describe">
            <div>{{item.pictureName}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div style="margin-top: 16px;overflow: hidden">
      <el-pagination
          class="page"
          :page-size="10"
          :current-page="currentPage"
          layout="prev, pager, next, jumper"
          :total="total"
          @current-change="changePage"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProductShowList",
    components: {},
    data() {
      return{
        loading: false,
        exportLoading: false,
        submitLoading: false,
        submitLoading1: false,
        submitLoading2: false,
        dialogVisible: false,
        adSearchShow: false,
        productShowList:[
          {pictureName:"电梯IC卡",filePath:"img/logo.png"},
          {pictureName:"电梯IC卡",filePath:"img/logo.png"},
          {pictureName:"电梯IC卡电梯IC卡电梯IC卡电梯IC卡",filePath:"img/logo.png"},
          {pictureName:"无",filePath:"img/logo.png"},
          {pictureName:"电梯IC卡",filePath:"img/logo.png"},
          {pictureName:"电梯IC卡",filePath:"img/logo.png"},
        ],
        idList: [],
        inputFilter: "",
        currentPage: 1,
        total: 0,
        filter:{
        },
      };
    },
    mounted() {
      // this.getList();
    },
    methods: {
      // getList(pageIndex) {
      //   this.currentPage = pageIndex;
      //   this.loading = true;
      //   let params = Object.assign({pageSize: 10, pageNum: pageIndex}, this.filter);
      //   this.$http.get("basic","products", params).then(res => {
      //     console.log(res);
      //     this.loading = false;
      //     let data = res;
      //     this.productShowList = data.records;
      //     this.total = data.total;
      //   }).catch(() => {
      //     this.loading = false;
      //     this.$message.error("获取失败");
      //   });
      // },
      changePage(pageIndex) {
        this.getList(pageIndex);
      },
      dialogClose() {
        this.$refs.form.resetFields();
        this.submitLoading = false;
      },
    },
  };
</script>

<style lang="scss">
  @media (min-width: 320px) and (max-width: 760px) {
    .productShow-main{
      ul{
        .productShow-main-li{
          width: 49%!important;
          div{
            font-size: 12px!important;
          }
        }
      }
    }

  }
  @media (min-width: 1450px) and (max-width: 1800px) {
    .productShow-main{
      ul{
        .productShow-main-li{
          width: 19%!important;
        }
      }
    }

  }
  @media (min-width: 1801px){
    .productShow-main{
      ul{
        .productShow-main-li{
          width: 300px!important;
        }
      }
    }
  }
.productShow{
  .productShow-main{
    ul{
      list-style: none;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      padding: 0 1% 0 0;
      margin: 0;
      .productShow-main-li{
        width: 24%;
        margin-left: 1%;
        list-style: none;
        position: relative;
        div{
          font-size: 1em;
          text-align: center;
        }
        .productShow-name{
          margin: 10px 0;
        }
        .productShow-img{
          border: 1px solid #dddddd;
          border-radius: 10px;
          height: 200px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .productShow-describe{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 96%;
          padding: 2%;
          background: #9a9a9a;
          color: #ffffff;
          border-radius: 0 0 10px 10px;
        }
      }
    }
  }
}
</style>
